import { useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useGetApplications } from '@/hooks';
import ApplicationsList from "@/components/applications/applications-list";

const AdminDisabledApplicationsPage = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data: responseData, isLoading, isError } = useGetApplications(
    'disabled',
    true,
    { page, limit: 20, search: search || undefined }
  );

  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ApplicationsList
      data={data}
      isLoading={isLoading}
      isError={isError}
      title={t('processManagement.allDisabledApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.errorOccurredWhileFetchingDisabledApplications')}
      searchPlaceholder={t('processManagement.search')}
      baseRoute="/admin/management/disabled-applications"
      noDataMessage={t('processManagement.noDisabledApplicationsFound')}
      meta={meta}
      search={search}
      onSearchChange={handleSearchChange}
      onPageChange={setPage}
    />
  );
};

export default AdminDisabledApplicationsPage;